/**
 * 简易翻译函数
 * 根据当前语言返回中文或英文
 * 用于模板中硬编码中文文本的翻译
 */
import langManager from "../model/lang";

var ZH_CN = {
  // 会议状态
  进行中: "In Progress",
  已结束: "Ended",
  未开始: "Not Started",
  会议已结束: "Meeting Ended",
  会议准备中: "Meeting Preparing",
  会议已经结束: "Meeting has ended",

  // 会议时间
  会议时间: "Meeting Time",
  距离会议开始: "Meeting starts in",
  距离大会: "Conference starts in",
  还有: " remaining",
  开始: "Start",
  结束: "End",

  // 时间单位
  天: "d",
  时: "h",
  分: "min",
  秒: "s",

  // 报名状态
  立即报名: "Register Now",
  "审核中...": "Under Review...",
  报名成功: "Registration Successful",
  拒绝报名: "Registration Rejected",
  "报名成功，期待您的莅临":
    "Registration successful, looking forward to your attendance",
  "报名成功,审核中": "Registration successful, under review",
  报名人数已满: "Registration Full",
  手机扫码立即报名: "Scan to register now",

  // 登录/注册/退出
  登录: "Login",
  注册: "Register",
  退出: "Logout",
  "你确定退出吗?": "Are you sure you want to logout?",
  简体中文: "简体中文",

  // 导航菜单
  大会介绍: "Introduction",
  大会简介: "Introduction",
  演讲嘉宾: "Speakers",
  参会嘉宾: "Speakers",
  大会日程: "Agenda",
  会议日程: "Agenda",
  热点资讯: "News",
  新闻资讯: "News",
  资料下载: "Downloads",
  合作媒体: "Partners",
  合作伙伴: "Partners",

  // 模块标题
  分会场日程: "Sub-venue Agenda",
  热门资讯: "Hot News",
  更多新闻资讯: "More News",
  更多合作伙伴: "More Partners",
  详情: "Details",

  // 暂无数据
  暂无数据: "No Data",

  // 第X天
  第: "Day ",

  // 嘉宾标签
  "公司：": "Company: ",
  "职位：": "Position: ",
  "简介：": "Bio: ",

  // 资料下载
  请输入您的邮箱: "Please enter your email",
  确定: "Confirm",
  已下载成功: "Download successful",
  请稍后查看您的邮箱: "Please check your email later",
  请输入正确邮箱: "Please enter a valid email",
  在线预览: "Online Preview",
  更多资料下载: "More Downloads",
  大会资料: "Conference Materials",

  // Footer
  联系我们: "Contact Us",
  "合作联系 xxx.xxx@outlook.com": "Contact: xxx.xxx@outlook.com",

  // Suspension
  "参会人ID：": "Attendee ID: ",
  现场需要向主办方出示: "Please present to the organizer on-site",
  长按识别二维码: "Long press to scan QR code",
  扫码分享海报: "Scan to share poster",
  微信扫一扫: "WeChat Scan",
  微信: "WeChat",
  分享: "Share",
  问卷: "Survey",
  返回顶部: "Back to Top",
  暂无问卷: "No survey available",

  // 已冻结
  已冻结: "Frozen",

  // 日期格式
  "YYYY年MM月DD日 HH:mm": "YYYY-MM-DD HH:mm",
  YYYY年MM月DD日: "YYYY-MM-DD",
  MM月DD日: "MM-DD",
};

/**
 * 翻译函数
 * @param {string} zh - 中文文本
 * @returns {string} 翻译后的文本（中文时返回原文）
 */
export function t(zh) {
  if (langManager.current === "zh_CN" || langManager.current === "zh-CN") {
    return zh;
  }
  return ZH_CN[zh] || zh;
}

/**
 * Vue mixin，提供 $t 方法给模板使用
 */
export var tMixin = {
  methods: {
    $t: t,
  },
};
